<template>
    <div class="birthday-navigation mt-3">
        <div class="nav-tabs-wrapper">
            <router-link 
                :to="{ name: 'BirthdayList' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'BirthdayList' }"
            >
                <i class="fas fa-birthday-cake"></i>
                <span>Daftar Ulang Tahun</span>
            </router-link>
            <router-link 
                :to="{ name: 'BirthdayTemplate' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'BirthdayTemplate' }"
            >
                <i class="fas fa-file-alt"></i>
                <span>Template Ucapan</span>
            </router-link>
            <router-link 
                :to="{ name: 'BirthdaySettings' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'BirthdaySettings' }"
            >
                <i class="fas fa-cog"></i>
                <span>Pengaturan</span>
            </router-link>
            <router-link 
                :to="{ name: 'BirthdayStats' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'BirthdayStats' }"
            >
                <i class="fas fa-chart-bar"></i>
                <span>Statistik & Laporan</span>
            </router-link>
            <router-link 
                :to="{ name: 'BirthdayImport' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'BirthdayImport' }"
            >
                <i class="fas fa-upload"></i>
                <span>Import Data</span>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BirthdayNavigation'
};
</script>

<style scoped>
.birthday-navigation {
    /* margin-bottom: 5px; */
    background: #fff;
    border-radius: 12px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8ecef;
}

.nav-tabs-wrapper {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.nav-tab-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    color: #6c757d;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
    position: relative;
    background: transparent;
    border: 1px solid transparent;
    white-space: nowrap;
}

.nav-tab-item i {
    font-size: 16px;
    width: 18px;
    text-align: center;
    transition: all 0.3s ease;
}

.nav-tab-item:hover {
    color: #1976d2;
    background: #f8f9fa;
    border-color: #e9ecef;
    transform: translateY(-1px);
}

.nav-tab-item.active {
    color: #fff;
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-color: #1976d2;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
    transform: translateY(-2px);
}

.nav-tab-item.active i {
    color: #fff;
    transform: scale(1.1);
}

.nav-tab-item.active:hover {
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    transform: translateY(-2px);
}

@media (max-width: 768px) {
    .nav-tabs-wrapper {
        flex-direction: column;
    }
    
    .nav-tab-item {
        width: 100%;
        justify-content: flex-start;
    }
    
    .nav-tab-item span {
        flex: 1;
    }
}

@media (max-width: 576px) {
    .birthday-navigation {
        padding: 6px;
    }
    
    .nav-tab-item {
        padding: 10px 16px;
        font-size: 13px;
    }
    
    .nav-tab-item i {
        font-size: 14px;
    }
}
</style>

